import { render } from "./PuzzleGradeListView.vue?vue&type=template&id=3080f8f9&scoped=true"
import script from "./PuzzleGradeListView.vue?vue&type=script&lang=js"
export * from "./PuzzleGradeListView.vue?vue&type=script&lang=js"

import "./PuzzleGradeListView.vue?vue&type=style&index=0&id=3080f8f9&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3080f8f9"]])

export default __exports__